module.exports = __webpack_public_path__ + "media/icons/czesci-20122b35.png";